(() => {
  if (window.nutrioneHomeViewport) return;
  window.nutrioneHomeViewport = true;
  const main = document.querySelector('#MainContent');
  const categories = main?.querySelector('.categories--symbols');
  const categorySection = categories?.closest('.shopify-section');
  const banner = categorySection?.previousElementSibling;
  if (!banner?.querySelector('.swiper-slideshow') || banner.parentElement !== main) return;
  const desktop = matchMedia('(min-width: 990px)');
  let frame;
  const update = () => {
    frame = null;
    if (!desktop.matches) {
      banner.classList.remove('home-viewport-banner');
      banner.style.removeProperty('--home-banner-height');
      categories.classList.remove('home-viewport-categories');
      categories.style.removeProperty('--home-categories-height');
      return;
    }
    const top = banner.getBoundingClientRect().top + scrollY;
    const style = getComputedStyle(categories);
    const naturalHeight = categories.querySelector('.categories__content').getBoundingClientRect().height
      + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    const available = document.documentElement.clientHeight - top - naturalHeight;
    const image = banner.querySelector('img');
    const ratio = image?.naturalWidth && image.naturalHeight ? image.naturalWidth / image.naturalHeight : 12 / 5;
    const bannerHeight = Math.max(220, Math.min(available, banner.clientWidth / ratio));
    banner.style.setProperty('--home-banner-height', `${bannerHeight}px`);
    banner.classList.add('home-viewport-banner');
    categories.style.setProperty('--home-categories-height', `${naturalHeight + Math.max(0, available - bannerHeight)}px`);
    categories.classList.add('home-viewport-categories');
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const observer = new ResizeObserver(schedule);
  observer.observe(categorySection);
  document.querySelectorAll('.shopify-section-group-header-group').forEach(e => observer.observe(e));
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  desktop.addEventListener('change', schedule);
  document.fonts.ready.then(schedule);
  banner.querySelector('img')?.addEventListener('load', schedule, { once: true });
  update();
})();
